import { createTheme } from '@mui/material/styles';

export const themeDark = createTheme({
  palette: {
    mode: 'dark',
  },
});

export const themeLight = createTheme({
  palette: {
    mode: 'light',
  },
});
